import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingUp } from "lucide-react";

export default function StaffKPI() {
  const [data, setData] = useState([]);
  useEffect(() => { api.get("/kpi?mine=true").then((r) => setData(r.data)); }, []);

  const avg = data.length ? data.reduce((a, b) => a + Number(b.score), 0) / data.length : 0;

  return (
    <div className="p-4 space-y-3" data-testid="staff-kpi">
      <h2 className="font-serif text-2xl font-bold flex items-center gap-2"><TrendingUp className="w-6 h-6 text-emerald-800" />KPI của tôi</h2>

      <div className="bg-emerald-900 text-white rounded-sm p-4 text-center">
        <div className="text-[10px] uppercase tracking-[0.25em] text-amber-300 font-bold">Trung bình</div>
        <div className="font-serif text-5xl font-bold mt-1">{avg.toFixed(1)}<span className="text-2xl">/100</span></div>
        <div className="text-xs text-stone-300 mt-1">{data.length} chỉ tiêu</div>
      </div>

      <div className="space-y-2">
        {data.map((k) => {
          const score = Number(k.score);
          const color = score >= 95 ? "bg-emerald-100 text-emerald-900" : score >= 80 ? "bg-amber-100 text-amber-900" : "bg-red-100 text-red-900";
          const barColor = score >= 95 ? "bg-emerald-700" : score >= 80 ? "bg-amber-600" : "bg-red-600";
          return (
            <div key={k.id} className="bg-white border border-stone-200 rounded-sm p-3">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <div className="text-[10px] uppercase tracking-wider text-stone-500 font-bold">{k.period}</div>
                  <div className="font-semibold">{k.metric}</div>
                </div>
                <span className={`text-xs px-2 py-0.5 rounded-sm font-bold ${color}`}>{score.toFixed(1)}</span>
              </div>
              <div className="h-2 bg-stone-100 rounded-sm overflow-hidden mb-1">
                <div className={`h-full ${barColor}`} style={{ width: `${Math.min(100, score)}%` }} />
              </div>
              <div className="text-xs text-stone-500 font-mono flex justify-between">
                <span>Mục tiêu: {k.target}</span>
                <span>Đạt: {k.actual}</span>
              </div>
            </div>
          );
        })}
        {data.length === 0 && <div className="text-center text-stone-400 py-12 text-sm">Chưa có KPI nào.</div>}
      </div>
    </div>
  );
}
